import React from "react";
import { Button } from "react-bootstrap";
import '../workflow.scss';
import ActionPanel from "../../../../../components/action-panel-modal/action-panel";
import ArchiveIcon from "../../../../../assets/icons/Icon - Archive-Large.svg";

const ArchivalModal = ({workflow, setWorkflowActionModal, acceptAction, header, mainText}) => {

    const onHide = () => {
        setWorkflowActionModal(false);
    };

    const onAccept= () => {
        if(header === "Archive Workflow"){
            acceptAction(workflow,true);
        }
        else if(header === "Un-Archive Workflow"){
            acceptAction(workflow,false);
        }
        else{
            acceptAction(workflow);
        }
        acceptAction(workflow);
        setWorkflowActionModal(false);
    };

    const text= <div className="workflow-modal-text">{mainText} <div className="workflow-name"><b>{workflow.Name}?</b></div></div>

    const acceptButton = <Button onClick={()=> onAccept()}>Yes</Button>;

    const rejectButton = (
        <Button className="btn-outlined" onClick={onHide}>
            No
        </Button>
    );

    return (
        <ActionPanel
            show={true}
            onHide={onHide}
            header={header}
            mainText={text}
            icon={ArchiveIcon}
            acceptButton={acceptButton}
            rejectButton={rejectButton}
        />
    )
}

export default ArchivalModal;